import { Component, Injectable } from "@angular/core";
import { SignalsMainComponent } from "./main.component";

@Component({
  selector: "app-signals-insights-create-edit",
  template: `<app-signals-message-create-edit
    [isScheduled]="false"
    title="Insights"
    location="messages"
  ></app-signals-message-create-edit>`,
  styleUrls: ["../styles/signalsMessages.component.css"],
})
@Injectable()
export class SignalsInsightsCreateEditComponent extends SignalsMainComponent {}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/components/scripts/signalsInsightsCreateEdit.component.ts